import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@material-ui/core";
import {
  ReferenceInput,
  SelectInput,
  useCreateSuggestionContext,
} from "ra-ui-materialui";
import { useCreate, useTranslate } from "ra-core";

import React from "react";
import { get } from "lodash";
import moment from "moment";
import { useFormState } from "react-final-form";

const CreateExecutiveProjectWorkPackage = () => {
  const formState = useFormState();
  const [loading, setLoading] = React.useState(false);
  const { filter, onCancel, onCreate } = useCreateSuggestionContext();
  const [value, setValue] = React.useState(filter || "");
  const [create] = useCreate("executive-project-work-packages");
  const translate = useTranslate();

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    create(
      {
        payload: {
          data: {
            type: "added",
            title: value,
            results: " - ",
            duration: 1,
            order_index: 10000,
            start_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            executive_project_id: formState.values.executive_project_id,
          },
        },
      },
      {
        onSuccess: ({ data }) => {
          setLoading(false);
          setValue("");
          onCreate(data);
        },
      }
    );
  };

  return (
    <Dialog open onClose={onCancel} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            label={translate(
              "resources.executive-project-work-packages.fields.title"
            )}
            value={value}
            onChange={(event) => setValue(event.target.value)}
            autoFocus
            multiline
            fullWidth
            required
            inputProps={{
              maxLength: 200,
            }}
            helperText={translate(
              "resources.executive-project-work-packages.fields.title.help_oneshot"
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit" disabled={loading}>
            {translate("ra.action.save")}
          </Button>
          <Button onClick={onCancel} disabled={loading}>
            {translate("ra.action.cancel")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const WorkPackageInput = ({ helperText, ...props }) => {
  const executiveProjectId = get(props, "record.executive_project_id");

  return (
    <ReferenceInput
      {...props}
      reference="executive-project-work-packages"
      sort={{ field: "order_index", order: "ASC" }}
      filter={{
        executive_project_id: executiveProjectId,
      }}
    >
      <SelectInput
        {...props}
        optionText={"full_title"}
        helperText={helperText}
        create={<CreateExecutiveProjectWorkPackage />}
        createLabel="resources.technical-report-activities.fields.executive_project_work_package.insert"
      />
    </ReferenceInput>
  );
};
export default WorkPackageInput;
